import React, { useState, useEffect } from 'react';


import '../properties/detail.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import InputGroup from 'react-bootstrap/InputGroup';

import { IoCheckmarkSharp } from "react-icons/io5";


import { FaWhatsapp } from "react-icons/fa";

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Gallery from '../../components/propertyGallery/gallery';
import FormatPrice from '../../components/property/formatPrice';
import RelatedProperties from '../../components/property/relatedProperty';
import FindValueByAttributeCode from '../../components/property/findValueByAttributeCode';

import Form from 'react-bootstrap/Form';

import config from '../../config/config'


import { IoLocation } from "react-icons/io5";
import { IoEye } from "react-icons/io5";



import { MdOutlineEmail } from "react-icons/md";

import { BsEnvelope } from "react-icons/bs";

import { IoWarningOutline } from "react-icons/io5";

import { LuShare2 } from "react-icons/lu";

import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";

import { useNavigate, useParams, useLocation } from "react-router-dom";

import {connect} from 'react-redux';
import * as actions from '../../store/project/actions';

import { BsBuilding } from "react-icons/bs";
import { MdCurrencyRupee } from "react-icons/md";

const Project =({ getProject, detail }) => {  
    const locationRoute =  useLocation();
    let match = useParams("/project/:slug"); 
    const navigate = useNavigate();
    const attributeNotDisplayInBluk= ['project_description', 'amenities', 'date_of_possession', 'flats_occupancy', 'is_rent', 'is_sale'];
    const [description, setDecription] = useState('');
    const [ amenities, setAmenities ] = useState('');
    const [ price, setPrice ] = useState('');
    const [ propertyType,  setPropertyType ] = useState()
    const [ propertyArea,  setPropertyArea ] = useState('')
    const [ mapLocation,  setMapLocation ] = useState('')

    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
		loadData();
	},[]);
    // console.log(detail)
    useEffect(() => {
        if(detail && detail != ''){
            
            const propertyPrice = detail.attributes.find(
                (attribute) => attribute.code === 'price'
            );
            setPrice(propertyPrice);

            const isOnRent = detail.attributes.find(
                (attribute) => attribute.code === 'is_rent'
            );
            
            if(isOnRent && isOnRent != ''){
                setPropertyType('Rent');
            } else {
                setPropertyType('Sale');
            }
            

            if(detail.location != ''){
                const locationOfProperty = "https://maps.google.com/maps?width=600height=400&hl=en&q="+detail.location+' '+detail.city+"&t=&z=14&ie=UTF8&iwloc=B&output=embed";
                // const locationOfProperty = "https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q="+detail.location+' '+detail.city+"&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed";
                setMapLocation(locationOfProperty);
                
            }
        }

	},[detail]);

    // console.log(detail)

    const loadData = async() => { 
        // console.log(match.slug)
        getProject({project: match.slug})
    }


    const downloadBrochure = async () => {
        const brochureUrl =  config.uploadUrl+'uploads/projects/brochure/'+detail.brochure;
        // console.log(brochureUrl);
        window.open(brochureUrl, "_blank");
        // const response = await fetch(brochureUrl);
        // const blob = await response.blob();
        // const url = window.URL.createObjectURL(blob);

        // const a = document.createElement("a");
        // a.href = url;
        // a.download = detail.brochure;
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        // window.location.href = brochureUrl;
    };

    const WhatsAppShare = ({ url, text }) => {
        // console.log('window.location.href', window.location.href)
        const encodedText = encodeURIComponent(text);
        const encodedUrl = encodeURIComponent(url);
        const whatsappLink = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
      
        return (
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-success"
          >
            <FaWhatsapp />
          </a>
        );
    };

    
    const FacebookShare = ({ url, text }) => {
        const encodedUrl = encodeURIComponent(url);
        const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      
        return (
          <a
            href={facebookLink}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-info"
          > <FaFacebookF />
          </a>
        );
    };

    const TwitterShare = ({ url, text }) => {
        const encodedText = encodeURIComponent(text);
        const encodedUrl = encodeURIComponent(url);
        const whatsappLink = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`;
      
        return (
          <a
            href={TwitterShare}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-primary"
          >
            <FaTwitter />
          </a>
        );
        
    }

    const SendSMS = ({ phone, message }) => {
        return <a className="btn btn-info" href={`sms:${phone}?body=${encodeURIComponent(message)}`}><MdOutlineEmail /> Message Via email</a>;
    };
    if(detail){
    return (
        <div>
            <Header/>            
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col>
                            <div className='mt-4 mb-4' xs={12}>                               
                                <Gallery Images={detail.images} folder={`/uploads/projects/pictures/`} />
                            </div>
                        </Col>
                        <Col lg={8} xl={9}>
                            <div className='card p-4'>
                            <h1>{detail.title}</h1>
                            <h6 className='text-primary'></h6>
                            <p className='text-muted'><IoLocation/> {detail.location}, {detail.city} &nbsp;  &nbsp;  &nbsp;  &nbsp; <IoEye /> 69,656 Viewed</p>
                            <hr/>
                            <Row>
                                <Col md={6}>
                                    <h5>Date of Possession</h5>
                                    <p><FindValueByAttributeCode  attributeCode={'date_of_possession'} attributes={detail.attributes} /></p>
                                </Col>
                                <Col md={6}>
                                    <h5>Flats occupancy:</h5>
                                    <p><FindValueByAttributeCode  attributeCode={'flats_occupancy'} attributes={detail.attributes} /> </p>
                                </Col>
                            </Row>
                            </div>
                            <div className='mt-4'>
                                <h4>Descriptions</h4>
                                <p><FindValueByAttributeCode  attributeCode={'project_description'} attributes={detail.attributes} /></p>
                            </div>                            
                            <div className='mt-4'>
                                <h4>Features</h4>
                                {
                                    detail.attributes && detail.attributes.length > 0 ?
                                    <ul className='d-flex navlist p-0 m-0'>
                                        {
                                            detail.attributes.map((attribute, attributeIndnex) => { 
                                                return attributeNotDisplayInBluk.includes(attribute.code) ? null : <li key={`propertyFeature${attributeIndnex}`}><span className="text-primary"><IoCheckmarkSharp/></span> {attribute.label}: {attribute.value == 1 ? 'Yes' : attribute.value}</li>
                                            })
                                        }
                                    </ul> 
                                    : ''
                                } 

                            </div>                            
                            {
                            detail.animities && detail.animities.length > 0
                            ?                            
                            <div className='mt-4'>
                                <h4>Other Amenities</h4>
                                <ul className='d-flex navlist p-0 m-0'>
                                    {
                                        detail.animities.map((aimity, animityIndex) => {
                                            return <li key={`otherAnimities${animityIndex}`}><span className="text-primary"><IoCheckmarkSharp/></span> {aimity.trim()}</li>
                                        })
                                    }
                                </ul>
                            </div> 
                            : ''
                            } 
                            {
                                detail.floor_plans && detail.floor_plans.length > 0 ?
                                    detail.floor_plans.map((floorPlan, floorPlanIndex) => {
                                        return <div className='mt-4' key={`floorPlan${floorPlanIndex}`}>
                                        <h4 className='mb-3'>{floorPlanIndex+1}BHK floor plan</h4>
                                        <img src={`${config.uploadUrl}/uploads/projects/floor_plans/${floorPlan.floor_plan_img}`} style={{maxWidth: '100%'}} />
                                    </div>
                                    })
                                : ''
                            }
                        </Col>
                        <Col lg={4} xl={3}>
                            <div className='card p-3'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    
                                    <h3><MdCurrencyRupee /> <FindValueByAttributeCode  attributeCode={'price_range'} attributes={detail.attributes} /></h3>
                                    {/* <Button variant='info'><IoMdHeartEmpty/></Button> */}
                                </div>
                                <hr/>
                                { 
                                    detail.brochure && detail.brochure != '' ? 
                                        <Button onClick={() => downloadBrochure()}>Download Brochure</Button>
                                    : ''
                                }
                                <hr/>
                                {
                                    detail.builder ? 
                                        <div className='posterBox d-flex align-items-center mb-2'>
                                                <figure className='mb-0 me-2'></figure>    
                                            <div>
                                                <div className='text-muted'>Project By:</div>
                                                <h6 className='mb-0'>{detail.builder.developer_title}</h6>
                                            </div>
                                        </div>
                                    : ''
                                }
                                <Button variant="success"><a href={`tel:${detail.builder.phone_number}`}>Contact Developer</a></Button>

                                {/* <p className='mb-0 mt-3'><BsEnvelope /> {detail.posted_by.email}</p>        */}
                                <hr/>
                                <h5>Ads Location</h5>                        
                                <div>
                                    <div className="mapouter">
                                        <div className="gmap_canvas">
                                            { mapLocation ? <iframe width='100%' className="gmap_iframe" frameBorder="0" scrolling="no" marginHeight="0" marginwidth="0" src={mapLocation}></iframe> : '' }
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                            <div className='card p-3 mt-4'>
                                <h3 className='mb-0'>Overview</h3>
                                <div>
                                    <div className='d-flex mt-2 mb-1 justify-content-between'>
                                        <span>Launching date:</span>
                                        <span className='text-muted'><FindValueByAttributeCode  attributeCode={'launching_date'} attributes={detail.attributes} /></span>
                                    </div>
                                    <div className='d-flex mt-2 justify-content-between'>
                                        <span>Total units:</span>
                                        <span className='text-muted'><FindValueByAttributeCode  attributeCode={'total_units'} attributes={detail.attributes} /></span>
                                    </div>
                                    <div className='d-flex mt-2 justify-content-between'>
                                        <span>Total towers:</span>
                                        <span className='text-muted'><FindValueByAttributeCode  attributeCode={'total_towers'} attributes={detail.attributes} /></span>
                                    </div>
                                </div>
                                <hr/>
                                {/* <h5 className='mb-0'><a href='#'><IoWarningOutline/> Report Abuse</a></h5> */}
                                <hr/>
                                <h5><LuShare2 /> Share Ads</h5>
                                <div>
                                    { WhatsAppShare(window.location.href, detail.title) }
                                    {TwitterShare(locationRoute.pathname, detail.title)}
                                    {FacebookShare(locationRoute.pathname, detail.title)}
                                </div>
                            </div>
                        </Col>
                        
                    </Row>
                </Container>
            </section>
        <Footer/>
    </div>
    )
} else {
    return null;
}
}
function mapStateToProps(state) {
    
    return {
        detail: state.property.detail
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getProject: (post) => dispatch(actions.getProject(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Project);